import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setTradingPlans } from './planSlice';

export const LoadTradingPlans = () => {
  const dispatch = useDispatch();
    const { isLoading: isLoadingProducts, refetch: getProducts } = useQuery(
        "trading-plans",
        async () => {
          return await apiClient.get("/api/trading-plans");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                dispatch(setTradingPlans(res.data.trading_plans));
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        getProducts();
      }, []);
 
}

export default LoadTradingPlans
